import calculateLvlPercentage from "./calculateLevelPercentage"

const levels = [
    {
        level: 1,
        initialExp: 0,
        endExp: 50,
    },
    {
        level: 2,
        initialExp: 50,
        endExp: 200,
    },
    {
        level: 3,
        initialExp: 200,
        endExp: 350,
    },
    {
        level: 4,
        initialExp: 350,
        endExp: 500,
    },
    {
        level: 5,
        initialExp: 500,
        endExp: 650,
    },
    {
        level: 6,
        initialExp: 650,
        endExp: 750,
    },
    {
        level: 7,
        initialExp: 750,
        endExp: 900,
    },
    {
        level: 8,
        initialExp: 900,
        endExp: 1000,
    },
    {
        level: 9,
        initialExp: 1000,
        endExp: 1300,
    },
    {
        level: 10,
        initialExp: 1200
    },
]

const returnLevelObject = (expPoints, lvl) => {
    const currentLevel = levels.find(({ level }) => level === lvl)
    let { initialExp, endExp, level } = currentLevel

    let intervalExp, lvlPercentage, lvlStatute, lvlMessage

    console.log(expPoints)
    console.log(expPoints >= initialExp && expPoints <= endExp)

    if (expPoints >= initialExp && expPoints <= endExp) {
        intervalExp = endExp - initialExp
        lvlPercentage = calculateLvlPercentage(expPoints, initialExp, intervalExp)
        return { lvlPercentage, level }
    } else if (expPoints > endExp) {
        console.log('adeus')
        let updatedLevel = lvl
        do {
            updatedLevel++
            let lvlExtraNotif = undefined
            let newLevel = levels.find(({ level }) => level === updatedLevel)
            console.log(newLevel)
            let { initialExp, endExp, level } = newLevel

            if (level === 2) {
                lvlExtraNotif = ` Pode agora visitar o Sri Lanka!`
            } else if (level === 4) {
                lvlExtraNotif = ` Pode agora visitar o Brasil!`
            } else if (level === 6) {
                lvlExtraNotif = ` Pode agora visitar a China!`
            }

            intervalExp = endExp - initialExp
            lvlStatute = currentLevel?.statute

            if (lvlExtraNotif) {
                lvlMessage = `Parabéns! Subiu para o nível ${level}.${lvlExtraNotif}`
            } else {
                if (newLevel === 10) {
                    lvlMessage = `Parabéns! Subiu para o nível ${level}. Atingiu o nível máximo, é um verdadeiro aventureiro!`
                } else {
                    lvlMessage = `Parabéns! Subiu para o nível ${level}.`
                }
            }

            lvlPercentage = calculateLvlPercentage(expPoints, initialExp, intervalExp)

            console.log(level)
            if (lvlPercentage < 100) {
                return { level, lvlPercentage, lvlStatute, lvlMessage }
            }

        } while (lvlPercentage >= 100)
    }
}

export default returnLevelObject